module.exports = __webpack_public_path__ + "static/img/login_code.a8aaaa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_code.png
// module id = A4Au
// module chunks = 1